import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=2b98e69b&scoped=true&"
import script from "./GalleryPage.vue?vue&type=script&lang=js&"
export * from "./GalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPage.vue?vue&type=style&index=0&id=2b98e69b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98e69b",
  null
  
)

export default component.exports